import nodata from "../../Utils/assets/img/leads_no_data_found_removebg.png"
import { useEffect, useLayoutEffect, useMemo, useRef, useState } from "react"
import { Button } from "react-bootstrap"
import useLocalStorageState from "use-local-storage-state"
import { useLocation, useNavigate, useSearchParams } from "react-router-dom"
import { Kanban } from "../../CommonComponents/kanban/Kanban"
import { IconArrowRight, IconCategoryFilled } from "@tabler/icons-react"
import { useGetRequest } from "../../Utils/hooks/QueryHandler"
import DeleteModal from "../DeleteModal"
import {
  DeleteRequest,
  GetRequest,
  PutRequest,
} from "../../Utils/hooks/ApiHandler"
import noDataFetched from "../../Utils/assets/img/noDataFetched.png"
import { toast } from "sonner"
import { components } from "react-select"
import { CreateDeal } from "./CreateDeal"
import { UpdateDeal } from "./UpdateDeal"
import { DealDetails } from "./DealDetails"
import { fetchTemporaryFilterData, getTodayDateValue, usePermissions } from "../../Utils/helpers/commonhelper"
import { AuthorizationCard } from "../../CommonComponents/AuthorizationCard"
import { EditPipelinePage } from "../PipelineComponents/EditPipelinePage"
import { CreatePipelinePage } from "../PipelineComponents/CreatePipelinePage"
import { DealHeader } from "./DealHeader"
import Select from "react-select"
import useCommonData from "../../Utils/actions/advanceFilteringAction"
import { useGetEssentials } from "../../Utils/hooks/useGetEssentials"
import { useGlobalState } from "../../Utils/hooks/useFilterQueryValue"
import { useQueryClient } from "react-query"
import { useSharedPipelinePermission } from "../../Utils/hooks/usePipelineSharedPermission"

// Utility function for encoding pipeline IDs for URL parameters
const encodePipelineId = (id) => {
  const base64 = btoa(id.toString())
  return base64.replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "")
}

const readDealsMetadata = () => {
  try {
    return JSON.parse(localStorage.getItem("dealsMetadata") || "{}") || {}
  } catch {
    return {}
  }
}

const patchDealsMetadata = (patch) => {
  localStorage.setItem(
    "dealsMetadata",
    JSON.stringify({
      ...readDealsMetadata(),
      ...patch,
    })
  )
}

const getValidTakenFollowupFilter = (metadata) => {
  const saved = metadata?.takenFollowupFilter
  if (
    metadata?.filterType?.filterName === "Taken Followups" &&
    saved?.from &&
    saved?.to
  ) {
    return {
      from: saved.from,
      to: saved.to,
      ownerId: saved.ownerId ?? "",
    }
  }
  return null
}
//menulist for add new products and services button in dropdown
const MenuList = (props) => {
  return (
    <>
      <components.MenuList {...props}>
        {props.children}
        <div
          style={{
            padding: "10px",
            borderTop: "1px solid #ddd",
            textAlign: "center",
            cursor: "pointer",
            color: "#2184ff",
            fontSize: "0.9rem",
          }}
          onClick={() => {
            // trigger your modal open here
            props.selectProps.onAddNew()
          }}
        >
          + Create Pipeline
        </div>
      </components.MenuList>
    </>
  )
}

export const Deals = () => {
  // to determine the state being passed from leads when a lead is being converted to a won state
  const location = useLocation();
  // the state contains the id of the lead that's being converted to won state
  const state = location.state || null;

  // getting essentials
  const { customer, setCustomer, headers, extras, navigate, customerId, loginUserId, userType } = useGetEssentials()

  // initializing query client to clear the details offcanvas cached data once the detail page is closed
  const queryClient = useQueryClient()

  // parsing deals local metadata
  const dealsMetadata = JSON.parse(localStorage.getItem('dealsMetadata'))

  const [PERMISSION, _] = useLocalStorageState("permission")

  // variable for query params
  const [searchParams, setSearchParams] = useSearchParams()
  const moduleName = searchParams.get("module")
  const moduleId = searchParams.get("id")

  // let idFromDashboard = state?.id || null
  const [initialDashboardPipelineId, setInitialDashboardPipelineId] = useState(state?.id || null)
  // State management for pipelines, stages, and leads
  const [pipelines, setPipelines] = useState([])
  const [selectedPipelineId, setSelectedPipelineId] = useState(() => {
    return sessionStorage.getItem("selectedDealPipelineId") || null
  })
  const [pipelineStages, setPipelineStages] = useState([])
  // for storing the pipeline data to pass down to the advance filtering component
  const [filterDropPipelineStage, setFilterDropPipelineStage] = useState([])

  const [dealsData, setDealsData] = useState([])
  const [refetchDealsData, setrefetchDealsData] = useState(false)
  // Form modal states
  const [showCreateDeal, setShowCreateDeal] = useState(false)
  const [showUpdateDeal, setShowUpdateDeal] = useState(false)
  // const [showFollowUp, setShowFollowUp] = useState(false)
  const [showDealDetails, setShowDealDetails] = useState(false)
  const [selectedDealId, setSelectedDealId] = useState(null)
  const [editDealId, setEditDealId] = useState(null)
  // const [followUpDealId, setFollowUpDealId] = useState(null)
  const [selectedStageId, setSelectedStageId] = useState(null)
  const [settingsDropdown, setSettingsDropdown] = useState(false)
  // Delete confirmation states
  const [showDeleteModal, setShowDeleteModal] = useState(false)
  const [deleteDealId, setDeleteDealId] = useState(null)
  const [showPipelineDeleteModal, setShowPipelineDeleteModal] = useState(false)
  const [pipelineToDelete, setPipelineToDelete] = useState(null)

  // checking and validating if the last selected filter still exist until then the state initialized would be false and no data or the heading would be renderd
  const [isInitialized, setIsInitialized] = useState(false)

  // state for force fetching the taken followup
  const [appliedTakenFollowupFilter, setAppliedTakenFollowupFilters] = useState(() =>
    getValidTakenFollowupFilter(dealsMetadata)
  )

  //delete modal loading state
  const [isDeleting, setIsDeleting] = useState(false)

  // // Search states for debounced search
  const [debouncedSearch, setDebouncedSearch] = useState("")

  // Pagination states for list view
  const [limit, setLimit] = useState(25)
  const [listOffset, setListOffset] = useState(0)
  const [cardOffset, setCardOffset] = useState(0)

  // Local storage for view settings
  const [currView, setCurrView] = useState(() => {
    return dealsMetadata?.currView || "card"
  })
  const activeOffset = currView === "card" ? cardOffset : listOffset
  const setActiveOffset =
    currView === "card" ? setCardOffset : setListOffset

  const [editPipeline, setEditPipeline] = useState(false)
  const [encodedId, setEncodedId] = useState(null)
  const [createPipeline, setCreatePipeline] = useState(false)


  // Tab focus tracking for handling tab switches
  const [isTabVisible, setIsTabVisible] = useState(true)
  const [forceRefetch, setForceRefetch] = useState(0)
  const mountedRef = useRef(true)

  // deal permission 
  const dealGrant = PERMISSION.deals
  const followupGrant = dealGrant.feature.followup
  const dealPipelineGrant = dealGrant.feature.pipeline

  // after completing won deal to show that deal in a blinking state
  useEffect(() => {
    if (!state) return
    setSelectedPipelineId(state?.pipelineId)
    setHighlightId(state.id);

  }, [state]);

  const columnOptions = [
    { id: "contact_full_name", label: "Name", mandatory: true },
    { id: "email", label: "Email" },
    { id: "contact_phone", label: "Phone" },
    { id: "owner", label: "Lead Owner" },
    { id: "requirement", label: "Requirement" },
    { id: "pipeline_stage_name", label: "Pipeline Stage Name" },
    { id: "lead_status", label: "Lead Status" },
    { id: "budget", label: "Budget" },
    { id: "source_title", label: "Source" },
    { id: "expected_closure_date", label: "Expected Closure Date" },
    { id: "followup_taken_by", label: "Followup Taken By" },
    { id: "followup_created_on", label: "Followup Created On" },
    { id: "created_on", label: "Created On" },
  ]

  // Initialize columns for the table - ALL columns visible by default
  const [columns, setColumns] = useState(() => {
    const saved = dealsMetadata?.visibleColumns
    const allColumns = columnOptions.map(col => col.label);
    if (saved) {
      try {
        return saved;
      } catch (e) {
        console.error("Error parsing visible columns:", e);
      }
    }
    // Default: all columns visible
    return allColumns;
  });

  // Filter states
  const [filterStates, setFilterState] = useState([])
  const [filteredDeals, setFilteredDeals] = useState(null)

  // // state for heading to display
  // const lastHeading = localStorage.getItem("deals_last_heading")
  const [heading, setHeading] = useState("All Deals")

  // state for filter dropdown of advance filtering
  const [filterDropdown, setFilterDropdown] = useState(false)

  // global state to manage the apply filter data parameters and current filtered states
  const [dealsFilterDataParams, setDealsFilterDataParams] = useGlobalState('dealsFilterParams', { currAdvFilter: false, applyFilterData: {} })

  // loading state for temporary filter data to be hydrated
  const [tempFilterDataLoading, setTempFilterDataLoading] = useState(false)
  // curr advance filter to store the current filter type between "apply" and "save as" in advance filter for respective pagination in apply filter
  const [currAdvFilter, setCurrAdvFilter] = useState(dealsFilterDataParams?.currAdvFilter || null)
  // // filter state to see the temoporary applied filter data,
  const [tempFilterData, setTempFilterData] = useState(null)

  // global value state for applying the pagination to temporary filter data
  const [dealsFilterValues, setDealsFilterValues] = useGlobalState("dealsApplyFilterQueryValues", { currAdvFilter: null, applyFilterData: {} })

  // filter categories to render within the heading dropdown
  const [filterCategories, setFilterCategories] = useState([])
  // state to store the advanced custom filter to fetch data on save
  const [customFilter, setCustomFilter] = useState(null)


  // for storing the parsed shared users to pass down to the pipeline share model where i will render these users with their respective permissions corresponding to that pipeline
  const [parsedSharedUsers, setParsedSharedUsers] = useState(null)

  // states for taken followups filter
  const [showCustomInputs, setShowCustomInputs] = useState(false);
  const [customFrom, setCustomFrom] = useState(() => {
    const saved = getValidTakenFollowupFilter(dealsMetadata)
    return saved?.from || getTodayDateValue()
  });
  const [customTo, setCustomTo] = useState(() => {
    const saved = getValidTakenFollowupFilter(dealsMetadata)
    return saved?.to || getTodayDateValue()
  });


  // owner dropdown options for taken followups in filter cards
  const [selectedCustomOwner, setSelectedCustomOwner] = useState(() => {
    const saved = getValidTakenFollowupFilter(dealsMetadata)
    if (saved?.ownerId === "all") {
      return { value: "all", label: "All" }
    }
    return null
  });

  //state to blink latest deal
  const [highlightId, setHighlightId] = useState(null)

  // we are declaring params here to ensure that the apply filter data gets fetched 
  const applyFilterDataParams = {
    filterValues: dealsFilterValues,
    selectedPipelineId: selectedPipelineId,
    currView: currView,
    offset: activeOffset,
    limit: limit,
    module_name: "deals",
    customerId: customerId,
    loginUserId: loginUserId,
    userType: userType,
    headers: headers,
    extras: extras,
    setTempFilterData: setTempFilterData,
    setLoading: setTempFilterDataLoading,
    setFilterState: setFilterState,
    setFilterDropdown: setFilterDropdown
  }

  useEffect(() => {
    setDealsFilterDataParams({
      currAdvFilter: currAdvFilter,
      applyFilterData: {
        ...applyFilterDataParams,
        filterValues: dealsFilterValues,
        currView: currView,
        selectedPipelineId: selectedPipelineId,
        offset: activeOffset,
        limit: limit,
      }
    })
  }, [currAdvFilter, activeOffset, limit, currView, selectedPipelineId, dealsFilterValues,])

  // Stored apply params still describe the previous view until the effect above
  // writes them. Hold the list skeleton until that view's payload arrives.
  useLayoutEffect(() => {
    if (currAdvFilter !== "apply") return
    if (!pipelines.length) return
    if (!dealsFilterValues?.["filter_values"]?.length) return
    const stored = dealsFilterDataParams?.applyFilterData
    const storedViewMatches =
      stored?.currView === currView &&
      stored?.offset === activeOffset &&
      stored?.limit === limit
    if (!storedViewMatches) {
      setTempFilterDataLoading(true)
    }
  }, [currAdvFilter, currView, activeOffset, limit, dealsFilterDataParams, dealsFilterValues, pipelines.length])

  useEffect(() => {
    if (!isInitialized) {
      const lastHeading = dealsMetadata?.filterType?.filterName
      const validTakenFollowup = getValidTakenFollowupFilter(dealsMetadata)

      if (lastHeading === "Taken Followups" && !validTakenFollowup) {
        setHeading("All Deals")
        patchDealsMetadata({
          filterType: { filterName: "All Deals", id: null },
          takenFollowupFilter: null,
        })
      } else {
        setHeading(lastHeading || "All Deals")
      }
      setIsInitialized(true)
    }
  }, [isInitialized, dealsMetadata])

  // Save view preference to localStorage
  useEffect(() => {
    localStorage.setItem("dealsMetadata", JSON.stringify(
      {
        ...dealsMetadata,
        currView: currView,
      }
    ))
  }, [currView])

  // common advance filter api calls that will be needed everywhere
  const { leadOwner, lead_source, company, contacts } = useCommonData({
    leadOwner: true,
    leadSource: true,
    companies: true,
    contacts: true
  })

  // Restore Taken Followups owner option once owner list is available
  useEffect(() => {
    const ownerId = appliedTakenFollowupFilter?.ownerId
    if (ownerId == null || ownerId === "") return
    if (ownerId === "all") {
      setSelectedCustomOwner({ value: "all", label: "All" })
      return
    }
    if (!leadOwner?.length) return
    const match = leadOwner.find((owner) => String(owner.value) === String(ownerId))
    if (match) {
      setSelectedCustomOwner(match)
    }
  }, [leadOwner, appliedTakenFollowupFilter?.ownerId])

  // Clear Taken Followups params when the user leaves that filter
  useEffect(() => {
    if (!isInitialized) return
    if (heading === "Taken Followups") return

    const current = readDealsMetadata()
    if (current.takenFollowupFilter != null) {
      patchDealsMetadata({ takenFollowupFilter: null })
    }

    setAppliedTakenFollowupFilters((prev) => (prev == null ? prev : null))
    setCustomFrom(getTodayDateValue())
    setCustomTo(getTodayDateValue())
    setSelectedCustomOwner(null)
  }, [heading, isInitialized])

  // Fetch all pipelines for the customer
  const {
    data: pipelineData,
    isLoading: isPipelineLoading,
    isError: pipelineDataError,
    refetch: refetchPipeline,
    status: pipelineFetchStatus
  } = useGetRequest(
    `lead/fetchPipelines/${customerId}/deals/${loginUserId}/${userType}`,
    ["fetchDealsPipeline", forceRefetch],
    headers,
    extras,
    {}
  )

  useEffect(() => {
    if (selectedPipelineId !== null && selectedPipelineId !== undefined) {
      sessionStorage.setItem("selectedDealPipelineId", String(selectedPipelineId))
    }
  }, [selectedPipelineId])

  useEffect(() => {
    if (pipelineFetchStatus === "success" && pipelineData) {
      const fetchedPipelines = pipelineData.data || []
      setPipelines(fetchedPipelines)

      const savedId = sessionStorage.getItem("selectedDealPipelineId")
      const savedExists = fetchedPipelines.some(
        (p) => String(p.id) === String(savedId)
      )

      if (savedExists) {
        setSelectedPipelineId(savedId)
      } else if (fetchedPipelines.length > 0) {
        const selectpipe =
          fetchedPipelines.find((el) => el.is_active === "yes") ||
          fetchedPipelines[0]

        setSelectedPipelineId(selectpipe?.id ?? null)

        if (selectpipe?.id != null) {
          sessionStorage.setItem("selectedDealPipelineId", String(selectpipe.id))
        }
      } else {
        setSelectedPipelineId(null)
      }
    } else {
      setPipelines([])
      setSelectedPipelineId(null)
    }
  }, [pipelineData, pipelineFetchStatus])

  const pipelineStageUrl = selectedPipelineId
    ? `lead/fetchPipelineStage/${selectedPipelineId}/${customerId}`
    : null

  // Fetch pipeline stages for selected pipeline
  const {
    data: pipelineStageData,
    isLoading: isPipelineStageLoading,
    isError: stageLoadingError,
    refetch: refetchPipelineStage,
    status: stageFetchStatus
  } = useGetRequest(
    pipelineStageUrl,
    ["fetchPipelineStage",
      selectedPipelineId,
    ],
    headers,
    extras,
    {
      enabled: !!selectedPipelineId,
    }
  )
  // Handle pipeline stage data updates and formatting
  useEffect(() => {
    if (stageFetchStatus === "success" && pipelineStageData) {
      const formattedStages = pipelineStageData.data.map((stage) => ({
        ...stage,
        stage_id: stage.id,
        sequence: String(stage.sequence),
        probability: Math.min(100, stage.probability || 0),
        rotting_days: stage.rotting_days === null ? null : stage.rotting_days,
        rotting_enabled: stage.rotting_days !== null && stage.rotting_days > 0,
      }))
      const filterDropdownData = pipelineStageData?.data.map((c) => ({
        value: c.id,
        label: c.stage_name
      }))
      setSelectedStageId(formattedStages[0]?.id)
      setPipelineStages(formattedStages)
      setFilterDropPipelineStage(formattedStages)
    } else {
      setPipelineStages([])
    }
  }, [pipelineStageData, heading])
  // Create params object
  const dealsParams = {}
  if (currView === "list") {
    dealsParams.limit = limit
    dealsParams.offset = activeOffset
  }
  if (debouncedSearch) {
    dealsParams.search = debouncedSearch
  }

  const { endpoint, queryKey } = useMemo(() => {

    if (!selectedPipelineId || currAdvFilter === 'apply') {
      return {
        endpoint: "",
        queryKey: "",
      }
    }

    // reseting filtervalues if current advance filter is null
    setDealsFilterValues({ filter_state: [], filter_values: [] })

    const customFilterId = dealsMetadata?.filterType?.id

    const lowerHeading = heading
      ? heading.toLowerCase().split(" ").join("_")
      : heading

    if (!customFilter && !customFilterId) {
      if (lowerHeading === "deals_created_by_me") {
        return {
          endpoint: `deals/dealsCreatedByMe/${loginUserId}/${customerId}/${selectedPipelineId}/${userType}/${currView}`,
          queryKey: "dealsCreatedByMe",
        }
      }

      if (lowerHeading === "deals_created_today") {
        return {
          endpoint: `deals/getDealsCreatedBasedOnDuration/${customerId}/today/${selectedPipelineId}/${loginUserId}/${userType}/${currView}`,
          queryKey: "dealsCreatedToday",
        }
      }

      if (lowerHeading === "deals_created_this_month") {
        return {
          endpoint: `deals/getDealsCreatedBasedOnDuration/${customerId}/month/${selectedPipelineId}/${loginUserId}/${userType}/${currView}`,
          queryKey: "dealsCreatedThisMonth",
        }
      }
      if (lowerHeading === "unqualified_deals") {
        return {
          endpoint: `deals/getDealsBasedOnStatus/${customerId}/${selectedPipelineId}/unqualified/${loginUserId}/${userType}/${currView}`,
          queryKey: "unqualifiedDeals",
        }
      }
      if (lowerHeading === "lost_deals") {
        return {
          endpoint: `deals/getDealsBasedOnStatus/${customerId}/${selectedPipelineId}/lost/${loginUserId}/${userType}/${currView}`,
          queryKey: "lostDeals",
        }
      }

      if (lowerHeading === "my_today_followup") {
        return {
          endpoint: `deals/fetchDealsBasedOnTodaysFollowup/${customerId}/month/${selectedPipelineId}/${loginUserId}/${userType}/${currView}/filter_card_id=null`,
          queryKey: "mytodayfollowup",
        }
      }

      if (lowerHeading === "taken_followups") {
        return {
          endpoint: `deals/fetchTakenFollowups/${customerId}/${selectedPipelineId}/${loginUserId}/${userType}/${currView}/filter_card_id=null?from=${appliedTakenFollowupFilter?.from}&to=${appliedTakenFollowupFilter?.to}&owner_id=${appliedTakenFollowupFilter?.ownerId || ""}`,
          queryKey: "takenfollowup",
        }
      }

      if (lowerHeading === "all_deals") {
        if (!moduleName) {
          return {
            endpoint: `deals/fetchDeals/${customerId}/${selectedPipelineId}/${loginUserId}/${userType}/${currView}`,
            queryKey: "fetchAllDeals",
          }
        }
        return {
          endpoint: `deals/fetchDeals/${customerId}/${selectedPipelineId}/${loginUserId}/${userType}/${currView}?module=${moduleName}&id=${moduleId}`,
          queryKey: moduleName === 'contact' ? "fetchContactDeals" : 'fetchCompanyDeals',
        }
      }
    }

    if (customFilter || customFilterId) {
      const id = customFilter?.id || customFilterId
      return {
        endpoint: `deals/fetchDeals/${customerId}/${selectedPipelineId}/${loginUserId}/${userType}/${currView}/${id}`,
        queryKey: `filterQuery${id}`,
      }
    }

    return {
      endpoint: "",
      queryKey: "",
    }
  }, [
    heading,
    filterCategories,
    selectedPipelineId,
    currView,
    appliedTakenFollowupFilter,
    customFilter,
    currAdvFilter
  ])

  const {
    data: dealsApiData,
    isLoading: isDealsLoading,
    isPreviousData: isDealsPreviousData,
    isError: dealsLoadError,
    refetch: refetchDeals,
  } = useGetRequest(
    endpoint,
    [
      queryKey,
      selectedPipelineId,
      forceRefetch,
      activeOffset,
      appliedTakenFollowupFilter
      // limit,
      // debouncedSearch,
    ],
    headers,
    { customer, setCustomer, rf: headers.Authentication, navigate },
    {
      ...dealsParams,
      enabled: !!selectedPipelineId && isTabVisible && currView,
    }
  )
  // keepPreviousData can leave card-shaped stages in the query result while list
  // is fetching. Do not sync that stale payload into list rows; show TableWrapper skeleton.
  useLayoutEffect(() => {
    if (isDealsPreviousData) {
      if (currView === "list") {
        setDealsData([])
      }
      return
    }

    const sharedUsers = dealsApiData?.pipeline_data?.["shared_to"]
    setParsedSharedUsers(JSON.parse(sharedUsers !== undefined && sharedUsers))

    setDealsData(dealsApiData?.data?.map(stage => ({
      ...stage,
      leads: stage.leads?.map(deal => ({
        ...deal,
        product_services:
          // typeof deal.product_services === "string"
          // ? (() => {
          //   try {
          //     return JSON.parse(deal.product_services)
          //   } catch {
          // return
          deal.product_services
        // }
        //     })()
        //     : deal.product_services
        // }))
      }))
    })
    ))

  }, [queryKey, dealsApiData, isDealsPreviousData, currView])

  // hook for getting the permissions assigned to the user
  // const { permissionAssigned, canEdit_canDownload } = usePermissions(
  //   customer,
  //   parsedSharedUsers,
  //   dealsApiData?.pipeline_data?.['added_by']
  // )

  // fetching shared pipeline permissions for the current selected pipline
  const { permissionAssigned, canEdit } = useSharedPipelinePermission(selectedPipelineId, customerId, loginUserId, userType, headers, extras, "deals")

  // customized filter cards for filtering data. These cards are supposed to be shown in filter cards dropdown
  const customFilterCards = (closeDropdown) => {
    return <div className="px-3 py-2 ">
      <div
        role="button"
        style={{ cursor: 'pointer', fontSize: '14px' }}
        className="d-flex gap-2 align-items-center ps-1"
        onClick={(e) => {
          e.stopPropagation();
          setShowCustomInputs(prev => !prev);
        }}
      >
        <IconCategoryFilled size={15} />
        Taken FollowUps
      </div>

      {showCustomInputs && (
        <div
          className="d-flex flex-column gap-2 mt-2"
          onClick={(e) => e.stopPropagation()}
        >
          <div className="d-flex gap-2 mt-2">
            <input
              type="date"
              className="form-control"
              value={customFrom}
              onChange={(e) => setCustomFrom(e.target.value)}
            />

            <input
              type="date"
              className="form-control"
              value={customTo}
              onChange={(e) => setCustomTo(e.target.value)}
            />
          </div>
          <div className="d-flex flex-column gap-2 mt-2">
            <div>
              <Select
                options={[
                  ...(leadOwner || []),
                  {
                    value: 'all', label: "All"
                  }
                ]}
                value={selectedCustomOwner}
                onChange={(selectedOption) => {
                  setSelectedCustomOwner(selectedOption || null);
                }}
                isSearchable
                styles={{
                  control: (base) => ({
                    ...base,
                    minHeight: "38px",
                    fontSize: "14px",
                  }),
                  placeholder: (provided) => ({
                    ...provided,
                    paddingLeft: "11px",
                  }),
                  menuPortal: (base) => ({
                    ...base,
                    zIndex: 99999,
                  }),
                }}
                placeholder="Select Owner"
                menuPortalTarget={document.body}
                menuPosition="fixed"
                menuShouldBlockScroll={true}
                captureMenuScroll={true}
              />
            </div>

          </div>
          <div className="d-flex align-items-center w-100 justify-content-end gap-2">
            <button
              className="btn btn-sm btn-default-outline w-50"
              onClick={async (e) => {
                e.stopPropagation();
                setShowCustomInputs(false)
                setCustomFrom(getTodayDateValue())
                setCustomTo(getTodayDateValue())
                setSelectedCustomOwner(null)
                setAppliedTakenFollowupFilters(null);
                setHeading("All Deals");
                patchDealsMetadata({
                  filterType: { filterName: "All Deals", id: null },
                  takenFollowupFilter: null,
                })
              }}
            >
              Cancel
            </button>
            <button
              className="btn btn-sm btn-default w-50"
              onClick={async (e) => {
                e.stopPropagation();
                const fromDate = customFrom || getTodayDateValue();
                const toDate = customTo || getTodayDateValue();
                const nextFilter = {
                  from: fromDate,
                  to: toDate,
                  ownerId: selectedCustomOwner?.value || "",
                }

                setAppliedTakenFollowupFilters(nextFilter);
                setShowCustomInputs(false)
                setHeading("Taken Followups")
                patchDealsMetadata({
                  filterType: { filterName: "Taken Followups", id: null },
                  takenFollowupFilter: nextFilter,
                })
                closeDropdown?.();
              }}
            >
              Submit
            </button>
          </div>
        </div>
      )}
    </div>
  }

  // Update lead stage with optimistic UI updates
  const handleUpdateDeal = async (dealData, newStageId, oldStageId) => {
    const originalDealsData = [...dealsData]
    // Optimistically update UI
    setDealsData((prev) => {
      const newData = [...prev]

      const oldStageIndex = newData.findIndex(
        (stage) => stage.stage_id === oldStageId
      )
      if (oldStageIndex !== -1) {
        newData[oldStageIndex] = {
          ...newData[oldStageIndex],
          leads: newData[oldStageIndex].leads.filter(
            (lead) => lead.lead_id !== dealData.lead_id
          ),
        }
      }

      const newStageIndex = newData.findIndex(
        (stage) => stage.stage_id === newStageId
      )
      if (newStageIndex !== -1) {
        newData[newStageIndex] = {
          ...newData[newStageIndex],
          leads: [...newData[newStageIndex].leads, dealData],
        }
      }

      return newData
    })
    const selectedPipeline = pipelines.find((p) => p.id === selectedPipelineId)
    const updatePayload = {
      customer_id: customerId,
      user_login_id: loginUserId,
      deal_id: dealData.lead_id,
      contact_id: dealData.contact_id,
      pipeline_id: selectedPipeline.id,
      pipeline_stage_id: newStageId,
      expected_closure_date: dealData.expected_closure_date,
      expected_closure_time: dealData.expected_closure_time,
      requirement: dealData.requirement,
      product_services: JSON.parse(dealData.product_services),
      budget: dealData.budget,
      lead_source_id: dealData.lead_source_id,
      deal_name: dealData.deal_name,
      currency_id: dealData.currency_id,
      owner_id: dealData.owner_id
    }

    try {
      const response = await PutRequest(
        `deals/updateDeal`,
        updatePayload,
        { headers },
        extras
      )

      if (response?.status === "success") {
        toast.success(response.message || "Lead updated successfully")
        if (currAdvFilter === "apply") {
          fetchTemporaryFilterData(applyFilterDataParams)
          return
        }
        setCurrAdvFilter(null)
        setFilterState([])
        setTempFilterData(null)
        setCustomFilter(null)
        setDealsFilterValues({ filter_values: [], filter_state: [] })
        refetchDeals()
      } else {
        toast.error(response?.message || "Failed to update lead")
        setDealsData(originalDealsData)
      }
    } catch (error) {
      toast.error(error.message || "Failed to save lead")
      setDealsData(originalDealsData)
    }
  }

  // Confirm and execute pipeline deletion
  const handlePipelineDeleteConfirm = async () => {
    if (!pipelineToDelete) return
    setIsDeleting(true)
    try {
      const response = await DeleteRequest(
        `lead/deletePipeline/${pipelineToDelete}/${customerId}/${loginUserId}/deals`,
        { headers },
        extras
      )
      if (response?.status === "success") {
        toast.success("Pipeline deleted successfully")
        setShowPipelineDeleteModal(false)
        setPipelineToDelete(null)
        setIsDeleting(false)
        await refetchPipeline()
        navigate(`/deals`)
      } else {
        toast.error(response?.message || "Failed to delete pipeline")
        setIsDeleting(false)
      }
    } catch (error) {
      toast.error("An error occurred while deleting pipeline")
      setIsDeleting(false)
    }
  }

  // Open add lead form
  const handleAddDeal = (stageId = null) => {
    if (!dealGrant?.isCreate) {
      toast.warning("You are not authorised for this action!")
      return
    }
    if (!canEdit) {
      toast.warning("You are not a shared pipeline user. You are not authorized for this action!")
      return
    }
    setSelectedStageId(stageId)
    setEditDealId(null)
    setShowCreateDeal(true)
  }

  // Open edit lead form with specific lead ID
  const handleEditDeal = (leadId) => {
    if (!dealGrant.isEdit) {
      toast.warning("You are not authorized for this action!")
      return
    }
    setEditDealId(leadId)
    setSelectedStageId(null)
    setShowUpdateDeal(true)
  }

  // Show delete confirmation modal for lead
  const handleDeleteDeal = (dealId) => {
    if (!dealGrant.isDelete) {
      toast.warning("You are not authorized for this action!")
      return
    }
    setDeleteDealId(dealId)
    setShowDeleteModal(true)
  }

  // Open lead details modal with proper lead ID
  const handleOpenDealDetails = (lead) => {
    setShowDealDetails(false)
    setSelectedDealId(null)

    setTimeout(() => {
      setSelectedDealId(lead.lead_id)
      setShowDealDetails(true)
    }, 50)
  }

  // Close lead details and refresh data
  const handleCloseDealDetails = () => {
    setShowDealDetails(false)
    setSelectedDealId(null)
    setrefetchDealsData(true)
    setIsDeleting(false)
    queryClient.removeQueries('fetchLeadDetails')
  }

  // Confirm and execute lead deletion
  const handleDeleteConfirm = async () => {
    setIsDeleting(true)
    try {
      const response = await DeleteRequest(
        `deals/deleteDeal/${deleteDealId}/${loginUserId}`,
        { headers },
        extras
      )

      if (response?.status === "success") {
        toast.success(response.message)
        setIsDeleting(false)
        if (currAdvFilter === "apply") {
          fetchTemporaryFilterData(applyFilterDataParams)
          return
        }
        setCurrAdvFilter(null)
        setFilterState([])
        setTempFilterData(null)
        setCustomFilter(null)
        setDealsFilterValues({ filter_values: [], filter_state: [] })
        await refetchDeals()
      } else {
        toast.error(response?.message || "Failed to delete Deal")
        setIsDeleting(false)
      }
    } catch (error) {
      toast.error("An error occurred while deleting deal")
      setIsDeleting(false)
    } finally {
      setShowDeleteModal(false)
      setDeleteDealId(null)
      setIsDeleting(false)
    }
  }

  // Close delete confirmation modal
  const handleDeleteClose = () => {
    setShowDeleteModal(false)
    setDeleteDealId(null)
  }

  // Close create lead form and reset selection
  const handleCreateDealClose = () => {
    setShowCreateDeal(false)
    setSelectedStageId(null)
  }

  const handleUpdateDealClose = () => {
    setShowUpdateDeal(false)
    setSelectedStageId(null)
  }

  // Pagination handlers
  const handlePageChange = (selectedPage) => {
    setActiveOffset(selectedPage.selected)
  }

  // Enhanced refetch handling
  // useEffect(() => {
  //   if (refetchDealsData && isTabVisible) {
  //     refetchDeals()
  //     setrefetchDealsData(false)
  //   }
  // }, [refetchDealsData, refetchDeals, isTabVisible])

  // Calculate pagination values
  const totalDeals = dealsApiData?.total_count || 0
  const pageCount = Math.ceil(totalDeals / limit)

  const selectedPipeline = pipelines.find((p) => p.id === selectedPipelineId)

  // isLoading will depend on all the loading stages when they are true and the rest of the error states are false.
  const isLoading =
    isPipelineLoading ||
    isPipelineStageLoading ||
    isDealsLoading

  // if there's some error while fetching the data then we will show a retry ui to the user
  const isErrorFetching =
    pipelineDataError || stageLoadingError || dealsLoadError

  if (createPipeline) {
    return (
      <CreatePipelinePage
        module_name="deal"
        refetchPipelineData={refetchPipeline}
        setCreatePipeline={setCreatePipeline}
        setSelectedPipelineId={setSelectedPipelineId}
      />
    )
  }

  if (editPipeline && encodedId) {
    return (
      <EditPipelinePage
        encodedId={encodedId}
        module_name="deal"
        refetch={refetchPipeline}
        refetchPipelineStage={refetchPipelineStage}
        setEditPipeline={setEditPipeline}
        pipelineCount={pipelines.length}
        pipelineGrant={dealPipelineGrant}
      />
    )
  }

  // if no permission for module then authorization card
  if (!dealGrant.isView) {
    return <div style={{ position: "absolute", left: "40%", top: "10rem" }}>
      <AuthorizationCard />
    </div>
  }

  return (
    <>
      {
        isLoading && (
          <div className="d-flex justify-content-center align-items-center" style={{ height: "90vh" }}>
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        )
      }

      {isErrorFetching &&
        < div
          className="d-flex flex-column justify-content-center align-items-center"
          style={{ height: "90vh" }}
        >
          <img src={noDataFetched} style={{ width: '640px' }} alt="no_data_found" />
          <h4 className="mt-3">Couldn't load your deals</h4>

          <p
            className="text-muted text-center"
            style={{ maxWidth: 450 }}
          >
            Something went wrong while loading the data.
            Please check your internet connection and try again.
          </p>

          <button
            className="btn btn-default mt-2"
            onClick={() => {
              setCurrAdvFilter(null)
              setFilterState([])
              setTempFilterData(null)
              setCustomFilter(null)
              setDealsFilterValues({ filter_values: [], filter_state: [] })
              refetchPipeline();
              refetchPipelineStage();
              refetchDeals();
            }}
          >
            Retry
          </button>
        </div >
      }
      {
        !isLoading && !isErrorFetching && !tempFilterDataLoading && pipelines.length === 0 &&
        < div
          className="d-flex flex-column justify-content-center align-items-center"
          style={{ height: "90vh" }}
        >
          <img src={noDataFetched} style={{ width: '640px' }} alt="no_data_found" />
          <h4 className="mt-3">No Pipelines Found</h4>

          <p
            className="text-muted text-center "
          >
            You haven't created any pipeline yet.
          </p>

          <Button
            onClick={() => {
              if (!dealGrant?.isCreate) {
                toast.warning("You are not authorized for this action!")
                return
              }
              setCreatePipeline(true)
            }}
            className="btn btn-default btn-sm mt-2"
          >
            Create Your first Pipeline
          </Button>
        </div>
      }

      {
        !isLoading && !isErrorFetching && pipelines.length > 0 &&
        <DealHeader
          currView={currView}
          dealId={selectedDealId}
          setCurrView={setCurrView}
          columns={columns}
          setColumns={setColumns}
          columnOptions={columnOptions}
          permissionAssigned={permissionAssigned}
          canEdit_canDownload={canEdit}
          // dealGrant={dealGrant}
          heading={heading}
          setHeading={setHeading}
          parsedSharedUsers={parsedSharedUsers}
          setActiveOffset={setActiveOffset}
          dealsData={dealsData}
          handleAddDeal={handleAddDeal}
          selectedPipelineId={selectedPipelineId}
          setSelectedPipelineId={setSelectedPipelineId}
          pipelines={pipelines}
          pipelineStages={pipelineStages}
          encodePipelineId={encodePipelineId}
          debouncedSearch={debouncedSearch}
          setDebouncedSearch={setDebouncedSearch}
          filterCategories={filterCategories}
          setFilterCategories={setFilterCategories}
          selectedPipeline={selectedPipeline}
          filterStates={filterStates}
          setFilterState={setFilterState}
          setEncodedId={setEncodedId}
          setCreatePipeline={setCreatePipeline}
          selectedStageId={selectedStageId}
          setEditPipeline={setEditPipeline}
          dealsApiData={dealsApiData}
          filterDropdown={filterDropdown}
          setFilterDropdown={setFilterDropdown}
          setTempFilterData={setTempFilterData}
          currAdvFilter={currAdvFilter}
          setCurrAdvFilter={setCurrAdvFilter}
          customFilterCards={customFilterCards}
          contacts={contacts}
          company={company}
          leadOwner={leadOwner}
          lead_source={lead_source}
          setCustomFilter={setCustomFilter}
          refetchDeals={refetchDeals}
          dealsMetadata={dealsMetadata}
          filterValues={dealsFilterValues?.filter_state}
          setDealsFilterValues={setDealsFilterValues}
        />
      }

      {/* Kanban board - Enhanced rendering logic */}
      {
        !isLoading && !isErrorFetching && pipelines.length !== 0 && (
          <Kanban
            tempFilterData={tempFilterData}
            canEdit_canDownload={canEdit}
            stages={pipelineStages}
            data={dealsData}
            setData={setDealsData}
            onUpdateLead={handleUpdateDeal}
            onAddLead={handleAddDeal}
            onEditLead={handleEditDeal}
            // onFollowUpLead={handleFollowUpLead}
            // totalDataCount={totalDeals}
            totalModuleDataCount={dealsApiData?.total_count}
            onDeleteLead={handleDeleteDeal}
            currView={currView}
            visibleColumns={columns}
            filteredLeads={filteredDeals}
            onOpenLeadDetails={handleOpenDealDetails}
            offset={activeOffset}
            limit={limit}
            // pageCount={pageCount}
            handlePageChange={handlePageChange}
            setOffset={setActiveOffset}
            setLimit={setLimit}
            mainGrant={dealGrant}
            followupGrant={followupGrant}
            headers={headers}
            extras={extras}
            module_name={'deal'}
            highlightId={highlightId}
            isDataLoading={
              isDealsLoading ||
              // keepPreviousData stays isPreviousData while apply disables listing GET (endpoint "")
              (currView === "list" && isDealsPreviousData && currAdvFilter !== "apply") ||
              tempFilterDataLoading
            }
            pipelineStage={filterDropPipelineStage}
            pipeline_id={selectedPipelineId}
            refetchData={refetchDeals}
            currAdvFilter={currAdvFilter}
            setFilterState={setFilterState}
            setFilterDropdown={setFilterDropdown}
            filterValues={dealsFilterValues}
            setTempFilterData={setTempFilterData}
            applyFilterDataParams={dealsFilterDataParams}
            tempFilterDataLoading={tempFilterDataLoading}
          />
        )
      }

      {/* Create/Edit Lead Modal */}
      {
        <CreateDeal
          show={showCreateDeal}
          onHide={handleCreateDealClose}
          setDealClose={setShowCreateDeal}
          editId={editDealId}
          stageId={selectedStageId}
          pipelineId={selectedPipelineId}
          refetchDeals={refetchDeals}
          moduleName="deal"

          currAdvFilter={currAdvFilter}
          applyFilterDataParams={dealsFilterDataParams}
          setCurrAdvFilter={setCurrAdvFilter}
          setFilterState={setFilterState}
          setTempFilterData={setTempFilterData}
          setCustomFilter={setCustomFilter}
          setDealsFilterValues={setDealsFilterValues}
        />
      }
      {
        <UpdateDeal
          show={showUpdateDeal}
          setShow={setShowUpdateDeal}
          onHide={handleUpdateDealClose}
          editId={editDealId}
          refetchDeals={refetchDeals}
          moduleName="deals"

          currAdvFilter={currAdvFilter}
          applyFilterDataParams={applyFilterDataParams}
          setCurrAdvFilter={setCurrAdvFilter}
          setFilterState={setFilterState}
          setTempFilterData={setTempFilterData}
          setCustomFilter={setCustomFilter}
          setDealsFilterValues={setDealsFilterValues}
        />
      }

      {/* {
        showDealDetails &&
        <DealDetails
          show={showDealDetails}
          setrefetchDealsData={setrefetchDealsData}
          onClose={handleCloseDealDetails}
          dealId={selectedDealId}
          pipelineStageData={pipelineStageData}
          refetchDeals={refetchDeals}
          canEdit_canDownload={canEdit}
          setSelectedStageId={setSelectedStageId}
        />
      } */}
      {/* Delete Deal Confirmation Modal */}
      <DeleteModal
        show={showDeleteModal}
        onClose={handleDeleteClose}
        onConfirm={handleDeleteConfirm}
        isLoading={isDeleting}
        message="Are you sure you want to delete this lead?"
      />

      {/* Pipeline Delete Confirmation Modal */}
      <DeleteModal
        show={showPipelineDeleteModal}
        onClose={() => {
          setShowPipelineDeleteModal(false)
          setPipelineToDelete(null)
        }}
        onConfirm={handlePipelineDeleteConfirm}
        isLoading={isDeleting}
        message="Are you sure you want to permanently delete this pipeline?"
      />
    </>
  )
}